import {useState} from 'react';

import Icon from 'components/Icon/Icon';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import './FontSizePicker.scss';

interface IFontSizePickerProps {
  value: any;
  handleChange: (value: number) => void;
}

const FontSizePicker = ({value, handleChange}: IFontSizePickerProps) => {
  const [showSizes, setShowSizes] = useState(false);

  const {postType} = useGlobalState((state) => state.postGenerator);

  const fontSizes = [10, 11, 12, 13, 14, 15, 16, 20, 24, 32, 36, 40, 48, 64];

  if (postType === 'facebookTimeline') fontSizes.push(72);
  if (postType === 'pubTV') fontSizes.push(...[72, 82, 94, 108, 128]);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setShowSizes(false);
  });

  const handleClickItem = (value: number) => {
    handleChange(value);
    setShowSizes(false);
  };

  return (
    <div ref={containerRef} className="font-size-picker">
      <button
        className={`font-size-picker__action ${showSizes ? 'font-size-picker__action--show-sizes' : ''}`}
        onClick={() => setShowSizes((currState) => !currState)}
      >
        {value}
        <Icon icon="chevron-down" />
      </button>
      {showSizes && (
        <ul className="font-size-picker__list">
          {fontSizes.map((size) => (
            <li
              className={`font-size-picker__list-item ${size === value ? 'font-size-picker__list-item--active' : ''}`}
              key={size}
            >
              <button onClick={() => handleClickItem(size)}>{size}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FontSizePicker;
